import React from "react";
import "./Comment.less";

function createComment(cmt) {
  if (typeof cmt.comment !== "object") {
    return { __html: cmt.comment };
  } else {
    return cmt.comment;
  }
}

// Annonymous user

// chim_dir: ""
// chim_full_name: ""
// cmt_id: "22170"
// comment: "something cool about this"
// datetime: "Just now"
// new: false
// otd_id: "16807"
// otd_title_add: "fam"
// user: "Random Fool"

// logged in
// chim_dir: "ryan"
// chim_full_name: "Ryan"
// cmt_id: "22165"
// comment: "odd scene"
// datetime: "Today @ (9:52 PM)"
// otd_id: "16807"
// otd_title_add: ""
// user: "ryanloggedin"

const Comment = ({ cmt }) => (
  <div className={`commentsWrapper ` + (cmt.new ? `highlight` : null)}>
    <div className="commentTop">
      <p>From: {cmt.chim_dir ? `${cmt.chim_full_name} Chimney` : cmt.user}</p>
      {cmt.otd_title_add && <p>Added: "{cmt.otd_title_add}" of the Day</p>}
    </div>
    <div className="commentMiddle">
      <div dangerouslySetInnerHTML={createComment(cmt)} />
    </div>
    <div className="commentDate">Posted: {cmt.datetime}</div>
  </div>
);

export default Comment;
